import { useEffect } from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { SalvarCCA, FormCCA } from '@actions/ccasActions';
import { mobMask } from '@utils/masks';
import { CCA } from '@models/CCA';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';

function CCAForm() {
  const ccas = useAppSelector((state) => state.ccas);
  const [form] = Form.useForm<CCA>();
  const dispatch = useAppDispatch();
  const submitForm = (values: CCA) => {
    dispatch(SalvarCCA(values));
  };
  useEffect(() => {
    form.resetFields();
    if (ccas.cca) {
      form.setFieldsValue(ccas.ccas.find((c) => c.id === ccas.cca));
    }
  }, [ccas.cca, ccas.ccas, form]);
  return (
    <div>
      <Modal
        open={ccas.formview}
        onCancel={() => dispatch(FormCCA(null, false))}
        title="Cadastro CCA"
        footer={[
          <Button onClick={() => dispatch(FormCCA(null, false))} key="2">
            Fechar
          </Button>,
          <Button key="3" type="primary" onClick={() => form.submit()} loading={ccas.savingcca}>
            Salvar
          </Button>,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={submitForm} name="ccaForm">
          <Form.Item style={{ display: 'none' }} name="id">
            <Input />
          </Form.Item>
          <Form.Item label="Nome" name="nome" rules={[{ required: true, message: 'Campo obrigatório' }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Código" name="codigo">
            <Input />
          </Form.Item>
          <Form.Item label="Responsável" name="responsavel">
            <Input />
          </Form.Item>
          <Form.Item label="Contato" name="contato" normalize={(v) => mobMask.format(mobMask.normalize(v))}>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
export default CCAForm;
